import "../shared/league.css";

/**
 * Giải Đấu kép KHÔNG có URL riêng: /league/:id và /league/:id/detail tự rẽ nhánh sang
 * DeLeagueLive khi league.type === 'DOUBLE-ELIMINATION', đúng như Swiss.
 *
 * Trang này chỉ là chỗ hạ cánh cho ai mở thẳng /league-de mà không có giải nào.
 */
export default function DeLeaguePage() {
  return (
    <div className="biadi">
      <div className="shell">
        <div className="pad">
          <div className="emptybox">Chọn một giải Đấu kép từ danh sách giải đấu để xem chi tiết.</div>
        </div>
      </div>
    </div>
  );
}
